export enum HamburgerItems {
  INO,
  COURSES,
  TEACHERS,
  BLOG,
  SUBSCRIPTION,
  FAQ,
  POLICY,
  NOTIFICATION,
  CONTACTUS,
  EXIT,
}
